/* eslint-disable prettier/prettier */
import { Link, useLocation } from 'react-router-dom'

import { destroyAuthSession } from '../redux/slices/session.slice'
import { useDispatch } from 'react-redux'

import { routes } from 'utils/routes'

import { BrandsIcon, CotegoryIcon, DashboardIcon, Info, NewCustomerIcon, OrderIcon, ProductIcon, SettingIcon } from 'assets/svg'


const LeftSideBar = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  return (
    <>
      <div className="flex h-full">
        <div className="flex flex-col justify-between">
          <div className="flex gap-4 max-h-[calc(100vh-222px)] overflow-y-auto">
            <ul className="flex inline-table flex-col items-center space-y-5 rounded-full bg-white p-2 py-3">
              <li>
                <Link to={routes.dashboard} className="flex items-center space-x-3">

                  <span
                    className={`${location.pathname === routes.dashboard ? 'bg-purple-900 text-white' : ''} inline-flex h-9 w-9 items-center justify-center rounded-full p-2 hover:bg-purple-900 hover:text-white lg:h-12 lg:w-12 lg:p-3`}
                  >
                    {/* <Templates className="h-4 w-4 lg:h-5 lg:w-5" />s */}
                    {/* <DashboardIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.orders ? ' text-white' : ''
                        }`}
                    /> */}

                    <DashboardIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.orders ? 'text-white' : ''
                        }`}
                    />
                  </span>

                  {/* <img src={Home} className="h-4 w-4 lg:h-5 lg:w-5" /> */}
                </Link>
              </li>
              <li>
                <Link
                  to={routes.orders}
                  className="flex items-center justify-center space-x-3 text-white"
                >
                  <span
                    className={`${location.pathname === routes.orders ? 'bg-purple-900 text-white' : ''} inline-flex h-9 w-9 items-center justify-center rounded-full p-2 hover:bg-purple-900 hover:text-white lg:h-12 lg:w-12 lg:p-3`}
                  >
                    {/* <Templates className="h-4 w-4 lg:h-5 lg:w-5" />s */}
                    <OrderIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.orders ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>
              {/* <li>
                <Link to={routes.deals} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center hover:bg-purple-900 hover:text-white justify-center rounded-full ${location.pathname === routes.deals ? 'bg-purple-900 text-white' : ''} p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <DealsIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.deals ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li> */}
              <li>
                <Link to={routes.products} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full  hover:bg-purple-900 hover:text-white ${location.pathname === routes.products ? 'bg-purple-900' : ''} p-2 text-white lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <ProductIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.products ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>
              <li>
                <Link to={routes.categories} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-purple-900 hover:text-white ${location.pathname === routes.categories ? 'bg-purple-900 text-white' : ''} p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <CotegoryIcon
                      className={`h-4 w-4 ${location.pathname === routes.categories ? 'text-black' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>
              <li>
                <Link to={routes.brands} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full  hover:bg-purple-900 hover:text-white ${location.pathname === routes.brands ? 'bg-purple-900 text-white' : ''} p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <BrandsIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.brands ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>

              <li>
                <Link to={routes.setting} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-purple-900 hover:text-white ${location.pathname === routes.setting ? 'bg-purple-900' : ''} p-2 text-white lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <SettingIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.setting ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>
              {/* <li>
                <Link to={routes.customers} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-purple-900 hover:text-white ${location.pathname === routes.customers ? 'bg-purple-900 text-white' : ''}  p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <CustomerIcon
                      className={`h-4 w-4 ${location.pathname === routes.customers ? 'text-black' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li> */}

              {/* <li>
                <Link to={routes.pages} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-purple-900 hover:text-white ${location.pathname === routes.pages ? 'bg-purple-900 text-white' : ''} p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <PagesIcon
                      className={`h-4 w-4 text-black ${location.pathname === routes.pages ? 'text-white' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li> */}
              <li>
                <Link to={routes.customers} className="flex items-center space-x-3 text-gray-700">
                  <span
                    className={`inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-purple-900 hover:text-white ${location.pathname === routes.customers ? 'bg-purple-900 text-white' : ''}  p-2 lg:h-12 lg:w-12 lg:p-3`}
                  >
                    <NewCustomerIcon
                      className={`h-4 w-4 ${location.pathname === routes.customers ? 'text-black' : ''
                        }`}
                    />
                  </span>
                </Link>
              </li>

            </ul>

            <div className="py-3 ">
              <ul className="flex h-full flex-col justify-between space-y-5">
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.dashboard} className="text-sm font-medium">
                    Dashboard
                  </Link>
                </li>
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.orders} className="text-sm font-medium">
                    Orders
                  </Link>
                </li>
                {/* <li className="min-h-[48px] flex items-center">
                  <Link to={routes.deals} className="text-sm font-medium">
                    Deals
                  </Link>
                </li> */}
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.products} className="text-sm font-medium">
                    Products
                  </Link>
                </li>
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.categories} className="text-sm font-medium">
                    Categories
                  </Link>
                </li>
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.brands} className="text-sm font-medium">
                    Brands
                  </Link>
                </li>
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.setting} className="text-sm font-medium">
                    Home Page Settings
                  </Link>
                </li>
                <li className="min-h-[48px] flex items-center">
                  <Link to={routes.customers} className="text-sm font-medium">
                    Customers
                  </Link>
                </li>

                {/* <li className="min-h-[48px] flex items-center">
                  <Link to={routes.pages} className="text-sm font-medium">
                    Pages
                  </Link>
                </li> */}
                {/* <li className="min-h-[48px] flex items-center">
                  <Link to={routes.newCustomer} className="text-sm font-medium">
                    New Signup&#39;s
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>

          <div className="flex gap-4">
            <ul className="flex flex-col rounded-full mx-2">
              <li>
                <Link to="#" className="flex items-center space-x-3 text-gray-700">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white p-2 hover:bg-purple-900 hover:text-white lg:h-12 lg:w-12 lg:p-3">
                    <Info className="h-4 w-4 lg:h-5 lg:w-5" />
                  </span>
                </Link>
              </li>
            </ul>

            <div className="hidden lg:block">
              <ul className="flex h-full flex-col justify-center">
                <li>
                  <button
                    onClick={() => {
                      if (window.confirm('Do you wish to sign out?')) {
                        dispatch(destroyAuthSession())
                      }
                    }}
                    className="text-sm font-medium"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default LeftSideBar
